import { TransactionData } from './types';

const parseNumber = (value: unknown): number => {
  if (value === null || value === undefined) return 0;
  const numericValue = Number(value);
  return Number.isNaN(numericValue) ? 0 : numericValue;
};

export const transformTransactionData = (apiData: any): TransactionData => {
  const clicks = parseNumber(apiData.company?.clicks ?? apiData.company?.cliks);
  const subscribedCount = parseNumber(apiData.company?.subscribed_count);
  const subscribersPercent =
    clicks > 0 ? Number(((subscribedCount / clicks) * 100).toFixed(2)) : 0;

  return {
    id: apiData.id,
    ofId: apiData.of_id,
    ofModelId: apiData.of_model_id,
    ofSubscriberId: apiData.of_subscriber_id,
    fee: apiData.fee,
    amount: apiData.amount,
    transactionType: apiData.transaction_type,
    owner: apiData.owner,
    createdAt: apiData.created_at,
    status: apiData.status ?? null,
    model: {
      id: apiData.model.id,
      ofId: apiData.model.of_id,
      avatar: apiData.model.avatar,
      name: apiData.model.name,
      ofUserName: apiData.model.of_user_name,
    },
    partner: apiData.partner,
    company: {
      createdAt: apiData.company.created_at,
      clicks,
      id: apiData.company.id,
      source: apiData.company.source,
      ofId: apiData.company.of_id,
      link: apiData.company.link,
      subscribedCount,
      subscribersPercent,
      type: apiData.company.type,
    },
    subscriber: {
      id: apiData.subscriber.id,
      ofId: apiData.subscriber.of_id,
      name: apiData.subscriber.name,
      username: apiData.subscriber.username,
    },
  };
};

type TransactionStatus = 'confirmed' | 'returned' | 'pending';

export const getTransactionStatus = (transaction: TransactionData): TransactionStatus => {
  const statusRaw = (transaction.status || '').toLowerCase().trim();
  if (
    ['done', 'loaded', 'confirmed', 'approved', 'success', 'paid', 'completed'].includes(statusRaw)
  ) {
    return 'confirmed';
  }
  if (
    ['undo', 'returned', 'refund', 'refunded', 'canceled', 'cancelled', 'failed'].includes(
      statusRaw
    )
  ) {
    return 'returned';
  }
  if (['loading', 'pending', 'in_progress', 'processing', 'waiting'].includes(statusRaw)) {
    return 'pending';
  }

  const amountNumber = parseNumber(transaction.amount);

  if (amountNumber < 0) {
    return 'returned';
  }

  const createdAtDate = new Date(transaction.createdAt);
  const now = new Date();
  const diffInMs = now.getTime() - createdAtDate.getTime();
  const diffInDays = diffInMs / (1000 * 60 * 60 * 24);

  if (diffInDays < 7) {
    return 'pending';
  }

  return 'confirmed';
};

